<template>
  <el-button @click="open" type="primary">圖片上傳</el-button>
</template>

<script>
  import {getToken} from "../api";

  export default {
    name: "FileUploader",
    methods: {
      open() {
        this.$alert(`<iframe class="upload" src="http://api.taipec.gugame.net/index.php?/upload/pic?TOKEN=${getToken()}"/>`,
          '圖片上傳', {dangerouslyUseHTMLString: true}
        )
      }
    }
  }
</script>

<style>
  iframe.upload {
    width: 380px;
    height: 200px;
  }
</style>